import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService, RoutesService} from '@raven';
import {PatronService} from '../../services/patron.service';
import {BranchSelectors, OrganizationSelectors, PatronSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-my-card',
  templateUrl: './my-card.component.html',
  styleUrl: './my-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MyCardComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly patronStatusSelectors = PatronSelectors.AccountStatus;
  public readonly branchSelectors = BranchSelectors.Auth;
  title = 'Patrons';

  constructor(public patronService: PatronService,
              public notificationService: NotificationService,
              public routingService: RoutesService,
              public router: Router,
              public route: ActivatedRoute) {
  }

  renewAccount(): void {
    this.patronService.renewAccount({
      successMessage: 'Your account was successfully renewed.',
      errorMessage: {
        409: 'Your account must be expired before attempting to renew.',
        424: () => {
          this.notificationService.showSnackbarError('Your account must be under the balance limit to be eligible for renewal.');
          this.router.navigate(['/profile'], {fragment: 'billing'});
        },
        default: 'Error renewing your account. Please contact library staff.',
      }
    });
  }

}
